import './header.css'

export default () => {
    class MainHeader extends HTMLElement {
        constructor() {
            super();
            this.lastScrollY = window.scrollY; // Store the last scroll position
            this.isHeaderVisible = true; // Track the visibility state of the header
            this.announcement = document.querySelector('[data-section="announcement-bar"]').clientHeight
            this.mainHeader = document.querySelector('[data-section="header"]').clientHeight + this.announcement
            this.isMac = /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
            this.initEventListeners();

        }

        initEventListeners() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            document.documentElement.style.setProperty('--headerHeight', `${this.offsetHeight}px`);

            window.addEventListener('scroll', () => this.handleScroll());

            this.querySelectorAll('a[data-module="search-bar"]').forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.toggleSearchBar()
                })
            })
            document.querySelectorAll('.search-bar__close').forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.toggleSearchBar()
                })
            })

            document.querySelectorAll('.search-bar__overlay').forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.toggleSearchBar()
                })
            })

            // mobile menu
            this.querySelector('button[data-header-burger-menu]').addEventListener('click', () => {
                const mobileMenu = this.querySelector('#mobile-menu');

                // Save the last focused element (the button)
                this.lastFocusedElement = document.activeElement;

                if (mobileMenu.getAttribute('default-open') !== 'true') {
                    mobileMenu.setAttribute('default-open', 'true');
                    document.body.classList.add('overflow-hidden');

                    // Focus trap: Disable tabbing outside mobile menu
                    this.trapFocus(mobileMenu);

                    // Move focus to the first focusable element in the mobile menu
                    const firstFocusableElement = mobileMenu.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    if (firstFocusableElement) {
                        firstFocusableElement.focus()
                    }
                }
            })


            document.querySelectorAll('button[data-close-menu]').forEach(closeBtn => {
                closeBtn.addEventListener('click', () => {
                    const mobileMenu = this.querySelector('#mobile-menu');
                    if (mobileMenu) {
                        mobileMenu.setAttribute('default-open', 'false');
                        document.body.classList.remove('overflow-hidden', 'overflow-y-hidden');

                        mobileMenu.querySelectorAll('slide-panel[default-open="true"]').forEach(item => {
                            item.setAttribute('default-open', 'false');
                        })

                        // Return focus to the last focused element or to the body
                        if (this.lastFocusedElement && document.contains(this.lastFocusedElement)) {
                            this.lastFocusedElement.focus()
                        } else {
                            document.body.focus()
                        }

                        // Release the focus trap
                        this.releaseFocusTrap()
                    }
                })
            })


            document.querySelectorAll('.second-level-menu').forEach(btn => {
                const handleMenuAction = () => {
                    const dataHandle = btn.getAttribute('data-handle')
                    if (document.querySelector(`slide-panel[data-value="${dataHandle}"`)) {
                        document.querySelector(`slide-panel[data-value="${dataHandle}"`).setAttribute('default-open', 'true');
                        // eslint-disable-next-line
                        btn.nextElementSibling.querySelector('.selected_item').innerHTML = btn.querySelector('span').innerHTML;
                    }
                    this.querySelector('#mobile-menu').scrollTop = 0
                    this.querySelector('#mobile-menu').classList.add('overflow-y-hidden')
                    // document.body.classList.add('overflow-y-hidden')
                }
                btn.addEventListener('click', () => {
                    handleMenuAction()
                });

                btn.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.keyCode === 13) {
                        handleMenuAction();
                    }
                });
            });

            document.querySelectorAll('.second-level-nav-parent-mob').forEach(btn => {
                btn.addEventListener('click', () => {
                    const dataHandle = btn.getAttribute('data-second-parent')
                    if (document.querySelector(`slide-panel[data-value="${dataHandle}"`)) {
                        document.querySelector(`slide-panel[data-value="${dataHandle}"`).setAttribute('default-open', 'true');
                        document.querySelector(`.second-level-nav-child-main[data-content="${dataHandle}"`).classList.add('second-level-nav-child-main-active');
                        // eslint-disable-next-line
                        btn.nextElementSibling.querySelector('.selected_item_second').innerHTML = btn.querySelector('.childlink-title').innerHTML
                    }
                    this.querySelector('#mobile-menu').scrollTop = 0
                    this.querySelector('#mobile-menu').classList.add('overflow-y-hidden')
                });
            });

            document.querySelectorAll('.back-to-menu-second').forEach(btn => {
                btn.addEventListener('click', () => {
                    const dataHandle = btn.getAttribute('data-value')
                    if (document.querySelector(`slide-panel[data-value="${dataHandle}"`)) {
                        document.querySelector(`slide-panel[data-value="${dataHandle}"`).setAttribute('default-open', 'false');
                    }
                    setTimeout(() => {
                        this.querySelector('#mobile-menu').classList.remove('overflow-y-hidden')
                    }, 100)

                })
            })

            document.querySelectorAll('.back-to-menu-third').forEach(btn => {
                btn.addEventListener('click', () => {
                    const dataHandle = btn.getAttribute('data-value')
                    if (document.querySelector(`slide-panel[data-value="${dataHandle}"`)) {
                        document.querySelector(`slide-panel[data-value="${dataHandle}"`).setAttribute('default-open', 'false');
                    }
                    setTimeout(() => {
                        // this.querySelector(`slide-panel[data-value="${dataHandle}"`).classList.remove('overflow-y-hidden')
                        this.querySelector(`slide-panel[data-value="${dataHandle}"`).classList.remove('overflow-y-hidden')
                    }, 100)

                })
            })


            this.querySelectorAll('.header-navigation_dropdown').forEach(dropdown => {
                dropdown.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            });

            // this.querySelectorAll('.header-navigation-item').forEach(item => {
            //   item.addEventListener('click', () => this.toggleDropdown(item));
            // });
            this.querySelectorAll('.header-navigation-item').forEach(item => {

                const mainDropdownId = item.getAttribute('data-parent')
                const dropdown =
                  document.querySelector(`.header-navigation_dropdown[data-child=${mainDropdownId}]`);

                item.addEventListener('mouseenter', () => {

                    if (dropdown) {
                        item.classList.add('main-menu-active')
                        // eslint-disable-next-line
                        dropdown.querySelectorAll('.second-level-nav-parent').forEach(item => {
                            item.classList.remove('active-second-level-nav-parent')
                        })
                        dropdown.querySelectorAll('.second-level-nav-parent')[0].classList.add('active-second-level-nav-parent')
                        // eslint-disable-next-line
                        dropdown.querySelectorAll('.second-level-nav-child-main').forEach(item => {
                            item.classList.remove('second-level-nav-child-main-active')
                        })

                        dropdown.querySelectorAll('.second-level-nav-parent')[0].click()
                    }
                });

                item.addEventListener('mouseleave', () => {
                    document.querySelectorAll('.header-dropdown-active').forEach((el)=>{
                        el.classList.remove('header-dropdown-active')
                    });
                    item.classList.remove('main-menu-active')
                })
            });

            this.querySelectorAll('.second-level-nav-parent').forEach(parentElement => {
                parentElement.addEventListener('click', () => this.toggleSecondLevelNav(parentElement));
            });

            const filterElements = [...document.querySelectorAll('.menu-second-title')]
            const filteredValue = filterElements.filter((el) => !el.querySelector('a'));

            this.querySelectorAll('.second-level-nav-parent').forEach((parentElement, index) => {
                filteredValue[index].addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        this.toggleSecondLevelNav(parentElement)
                    }
                });
            })

            document.addEventListener('keydown', (ev) => {

                if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
                    this.changeFocusUpDown(ev);
                }

                if (ev.key === 'ArrowRight' || ev.key === 'ArrowLeft') {
                    this.changeFocusLeftRightNavContent(ev);
                }

                if (ev.key === 'Enter' && ev.target.tagName.toLowerCase() === 'a') {
                    const item = ev.target.parentElement;
                    const mainDropdownId = item.getAttribute('data-parent');

                    const dropdown =
                      document.querySelector(`.header-navigation_dropdown[data-child=${mainDropdownId}]`);
                    if (dropdown) {
                        dropdown.classList.add('header-dropdown-active')
                        //    item.classList.toggle('header-navigation_dropdown');
                        item.classList.add('main-menu-active');

                        // eslint-disable-next-line
                        dropdown.querySelectorAll('.second-level-nav-parent').forEach(item => {
                            item.classList.remove('active-second-level-nav-parent')
                        })
                        dropdown.querySelectorAll('.second-level-nav-parent')[0].classList.add('active-second-level-nav-parent')
                        // eslint-disable-next-line
                        dropdown.querySelectorAll('.second-level-nav-child-main').forEach(item => {
                            item.classList.remove('second-level-nav-child-main-active')
                        })

                        dropdown.querySelectorAll('.second-level-nav-parent')[0].click()
                    }

                }

                if (ev.key === 'Enter') {
                    const label = ev.target.getAttribute('aria-label')
                    if (label?.toLowerCase() === 'select country') {
                        this.trapFocus(document.querySelector('.ge-modal'))
                    }
                    setTimeout(() => {
                        const elem = document.querySelector('.ge-modal');

                        const isContain = elem.classList.contains('hidden_1');
                        if (document.activeElement === this.firstFocusableElement
                          && isContain && elem.getAttribute('aria-labelledby') === 'country-selector') {
                            const modal = document.querySelectorAll('[aria-label="Select country"]')[1];
                            modal.focus();
                        }

                        const btn= document.querySelector('#swym-wishlist-modal');
                        const modal= document.querySelector('#wishlist-modal');
                        const attr= modal.getAttribute('default-open');
                        const closeBtn= document.querySelector('#wishlist-modal-close');

                        if (attr === 'false' && document.activeElement === closeBtn) {
                            btn.focus();
                        }
                    })
                }
            })
        }

        changeFocusUpDown(ev) {
            const item = ev.target.parentElement;
            const activeElement = document.activeElement.closest('.menu-second-title');

            if (activeElement) {
                const childDropdownId = item.getAttribute('data-title');

                const parentDiv =
                  document.querySelector(`.header-navigation_dropdown[data-child=${childDropdownId}]`);

                const dropdown = parentDiv.querySelectorAll('.menu-second-title');
                // eslint-disable-next-line
                const focusables = Array.from(dropdown).map((element) =>
                  element.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                );

                const currentIndex = Array.from(focusables).indexOf(document.activeElement);

                let nextIndex;

                if (ev.key === 'ArrowDown') {
                    nextIndex = (currentIndex + 1) % focusables.length;
                } else if (ev.key === 'ArrowUp') {
                    nextIndex = (currentIndex - 1 + focusables.length) % focusables.length;
                }
                focusables[nextIndex].focus();
                ev.preventDefault()
            }
        }

        changeFocusLeftRightNavContent(ev) {
            const item = ev.target.parentElement;
            const activeContent = item.closest('.second-level-nav-child-active');
            if (activeContent){
                const activeContentChildren = activeContent.children;
                if (activeContentChildren.length) {
                    // eslint-disable-next-line
                    const focusables = Array.from(activeContentChildren).map((element) => {
                        return element.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                    });

                    const currentIndex = Array.from(focusables).indexOf(document.activeElement);

                    let nextIndex;

                    if (ev.key === 'ArrowRight') {
                        nextIndex = (currentIndex + 1) % focusables.length;
                    } else if (ev.key === 'ArrowLeft') {
                        nextIndex = (currentIndex - 1 + focusables.length) % focusables.length;
                    }
                    focusables[nextIndex].focus();
                    ev.preventDefault()
                }
            }

        }


        toggleDropdown(item) {
            const parentId = item.getAttribute('data-parent');
            const isActive = item.querySelector('a').classList.contains('active-nav-item');

            // If the clicked item is already active, close it
            if (isActive) {
                // Remove active class from all navigation items
                this.querySelectorAll('.header-navigation-item a').forEach(navItem => {
                    navItem.classList.remove('active-nav-item');
                });

                // Remove active class from all dropdowns
                this.querySelectorAll('.header-navigation_dropdown').forEach(dropdown => {
                    dropdown.classList.remove('header-dropdown-active');
                });

                return; // Exit the function as the dropdown is being closed
            }

            // Otherwise, proceed to open the clicked dropdown
            this.querySelectorAll('.header-navigation-item a').forEach(navItem => {
                navItem.classList.remove('active-nav-item');
            });

            item.querySelector('a').classList.add('active-nav-item');
            this.querySelectorAll('.header-navigation_dropdown').forEach(dropdown => {
                dropdown.classList.remove('header-dropdown-active');
            });

            const matchingDropdown = this.querySelector(`.header-navigation_dropdown[data-child="${parentId}"]`);
            if (matchingDropdown) {
                matchingDropdown.classList.add('header-dropdown-active');
            }
        }


        toggleSecondLevelNav(parentElement) {
            this.querySelectorAll('.active-second-level-nav-parent').forEach(parent => {
                parent.classList.remove('active-second-level-nav-parent');
            });

            const parentId = parentElement.getAttribute('data-second-parent');

            // Add active class to the clicked parent element
            parentElement.classList.add('active-second-level-nav-parent');

            this.querySelectorAll('.second-level-nav-child-main').forEach(childContent => {
                childContent.classList.remove('second-level-nav-child-main-active');
            });

            this.querySelectorAll('.second-level-nav-child-content')
                .forEach(childContent => {
                    childContent.classList.remove('second-level-nav-child-active');
                });

            const matchingChildMain =
                this.querySelector(`.second-level-nav-child-main[data-second-child="${parentId}"]`);
            if (matchingChildMain) {
                matchingChildMain.classList.add('second-level-nav-child-main-active');

                const matchingChildContent = matchingChildMain.querySelector('.second-level-nav-child-content');
                if (matchingChildContent) {
                    matchingChildContent.classList.add('second-level-nav-child-active');
                }
            }
        }


        handleScroll() {
            const currentScrollY = window.scrollY;
            if (currentScrollY >= 40) {
                document.querySelector('.header').classList.add('header-sticky');
            }

            if (currentScrollY > this.lastScrollY && currentScrollY > this.mainHeader && this.isHeaderVisible) {
                // Scrolling down, hide the header
                this.hideHeader();
            } else if (currentScrollY < this.lastScrollY && !this.isHeaderVisible) {
                // Scrolling up, show the header
                this.showHeader();
            }

            if (currentScrollY === 0) {
                document.querySelector('.header').classList.remove('header-hidden');
                document.querySelector('.header').classList.remove('header-sticky');
            }

            this.lastScrollY = currentScrollY;
        }

        hideHeader() {
            document.querySelector('.header').classList.add('header-hidden');
            this.isHeaderVisible = false;
        }

        showHeader() {
            document.querySelector('.header').classList.remove('header-hidden');
            document.querySelector('.header').classList.add('header-sticky');
            this.isHeaderVisible = true;
        }

        // Function to trap focus inside the mobile menu
        trapFocus(dialog) {
            const focusableElements = dialog.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

            const removeHiddenButtons = [...focusableElements].filter((el) => {
                const parent = el.parentElement;
                return !parent.classList.contains('hidden');
            });


            const firstFocusableElement = removeHiddenButtons[0];
            const lastFocusableElement = removeHiddenButtons[removeHiddenButtons.length - 1];

            setTimeout(() => {
                const label = dialog.getAttribute('aria-labelledby')
                if (label != null) {
                    if (label.toLowerCase() === 'country-selector') {
                        firstFocusableElement.focus();
                    }
                }
            }, 0);

            document.addEventListener('click', () => {
                // event.preventDefault();
                // firstFocusableElement.focus();
            });

            dialog.addEventListener('keydown', (e) => {

                if (e.key === 'Tab') {
                    if (e.shiftKey) { // Shift + Tab
                        if (document.activeElement === firstFocusableElement) {
                            e.preventDefault();
                            lastFocusableElement.focus(); // Move focus to last element if Shift + Tab on first element
                        }
                    } else {
                        // eslint-disable-next-line
                        if (document.activeElement === lastFocusableElement) {
                            e.preventDefault();
                            firstFocusableElement.focus(); // Move focus to first element if Tab on last element
                        }
                    }
                    if (document.activeElement === lastFocusableElement) {
                        e.preventDefault();
                        firstFocusableElement.focus(); // Move focus to first element if Tab on last element
                    }
                }
            });

            this.firstFocusableElement = firstFocusableElement
            this.lastFocusableElement = lastFocusableElement
        }

        // Function to release the focus trap
        releaseFocusTrap() {
            const dialog = this.querySelector('.search-bar');
            if (dialog) {
                dialog.removeEventListener('keydown', this.trapFocus);
            }
        }

        toggleSearchBar() {
            const searchBar = document.querySelector('.search-bar')
            const searchBarMain = document.querySelector('.search-bar__main')
            const announcementBar = document.querySelector('section[data-section="announcement-bar"]')
            searchBar.classList.toggle('is-active-search-bar')
            searchBarMain.classList.toggle('is-active-search-bar__main')
            document.body.classList.toggle('overflow-hidden')

            const scrollOffsetTop = window.scrollY
            if (scrollOffsetTop > 0) {
                searchBarMain.style.top = `${this.offsetHeight + 1}px`;
            } else {
                searchBarMain.style.top = `${this.offsetHeight + announcementBar.offsetHeight}px`;
            }

            if (searchBar.classList.contains('is-active-search-bar')) {
                // Save the last focused element (the button that opened the search bar)
                this.lastFocusedElement = document.activeElement;

                // Trap the focus within the search bar
                this.trapFocus(searchBar);
                const inputElement = searchBar.querySelector('input.search-form__input');
                if (inputElement) {
                    setTimeout(() => {
                        inputElement.focus();
                    }, 300);
                }
                // Focus the first focusable element in the search bar
                const firstFocusableElement = searchBar.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (firstFocusableElement) {
                    firstFocusableElement.focus();
                }
            } else {
                // Release focus trap and return focus to the last focused element
                this.releaseFocusTrap();
                if (this.lastFocusedElement && document.contains(this.lastFocusedElement)) {
                    this.lastFocusedElement.focus();
                } else {
                    document.body.focus();
                }
            }
        }

        disconnectedCallback() {
            this.querySelectorAll('a[data-module="search-bar"]').forEach(link => {
                link.removeEventListener('click', this.toggleSearchBar.bind(this));
            });
            this.querySelectorAll('.search-bar__close').forEach(button => {
                button.removeEventListener('click', this.toggleSearchBar.bind(this));
            });

            document.querySelectorAll('.search-bar__overlay').forEach(item => {
                item.removeEventListener('click', this.toggleSearchBar.bind(this));
            })
        }
    }

    const init = () => {
        if (!customElements.get("main-header")) {
            customElements.define('main-header', MainHeader);
        }
    };

    init();
};
